import './Sec7Maturity.css';
import Img from '../../Images/pari-keynote-2024-thumb.png';
import React, { useState } from 'react'
import VideoModal from '../VideoModal/VideoModal';

function Sec7Maturity() {

  const [videoId, setVideoId] = useState('h1Q-3Gx4PZ0'); // Replace with your video ID
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (youtubeInput) => {
    // Extract video ID from URL if needed
    const extractedId = youtubeInput.match(/embed\/([^?]*)/)?.[1] || youtubeInput;
    setVideoId(extractedId);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);


  return (
    <div className="Sec7Maturity-container container">
      <div className='Sec7Maturity-sub-container'>
            <div>
              <h3 className="Sec7Maturity-title">Maturity of the GCC Ecosystem</h3>
              <p className="Sec7Maturity-description text">
                  The maturity of <a href="https://businessworld.in/article/india%E2%80%99s-gcc-market-revenues-to-touch-99-105-bn-by-2030-532640 " target='_blank' rel='noreferrer nofollow'>India’s GCC ecosystem</a> can also be attributed to the inherent quality, transparency, and trust established among stakeholders in the value chain.
                  <br/><br/>
                  Zinnov, its 24+ years of experience, has enabled 220+ GCCs, employing 250000+ professionals for Fortune 2000 and Mid-market enterprises globally.
              </p>
            </div>

            <div className='Sec7Maturity-img'>
              <img src={Img} alt="Maturity Illustration" onClick={() => openModal('h1Q-3Gx4PZ0')}/>
            </div>
      </div>
     
      <p className="Sec7Maturity-description text">
        With these centers reaching operational efficiency and beginning to impact their top line in as little as <a href='https://www.youtube.com/watch?v=_PQUcauC5tQ' target='_blank' rel='noreferrer nofollow'>90 days</a>, such rapid development is indicative of the robust infrastructure and streamlined processes that have been established in India, fostering an environment conducive to innovation, <a href='https://zinnov.com/centers-of-excellence/what-is-center-of-excellence-coe-and-why-should-organizations-set-it-up-blog/' target='_blank'>Centers of Excellence (COEs)</a>, and product ownership.
      </p>
      {isOpen && <VideoModal videoId={videoId} isOpen={isOpen} onClose={closeModal} overlayProps={{ style: { zIndex: 9999 } }} />}
    </div>
  )
}

export default Sec7Maturity;